import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import calculatorData from "../data/calculatorData";
import trackEvent, { reportablePath } from "../elements/trackEvent";
import { loadAnalytics } from "./externalServices";

const calculatorPaths = new Set(["/", ...calculatorData.map(({ path }) => path)]);
export function referralSource(referrer) {
  if (!referrer) return "direct";
  try {
    const host = new URL(referrer).hostname.toLowerCase();
    if (["chatgpt.com", "chat.openai.com"].includes(host)) return "chatgpt";
    if (host === "claude.ai") return "claude";
    if (/^(www\.)?(google\.[a-z.]+|bing.com|duckduckgo.com)$/.test(host)) return "search";
    return "referral";
  } catch { return "referral"; }
}

/** Counts deliberate use without reading any field value or storing a session. */
export default function UsageObserver() {
  const { pathname } = useLocation();
  const initial = useRef(true);
  useEffect(() => {
    loadAnalytics();
    trackEvent("page_view", { page_path: pathname, source: initial.current ? referralSource(document.referrer) : "internal" });
    initial.current = false;
    let started = false;
    const onInput = (event) => {
      if (!started && calculatorPaths.has(pathname) && event.target.closest?.("form")) {
        started = true;
        trackEvent("calculator_started", { page_path: pathname, interaction: "input" });
      }
      if (event.type === "change" && event.target.type === "checkbox" && event.target.checked && /compare/i.test(event.target.id)) {
        trackEvent("comparison_used", { page_path: pathname, interaction: "compare" });
      }
    };
    const onClick = (event) => {
      const anchor = event.target.closest?.("a[href]");
      if (!anchor) return;
      let url;
      try { url = new URL(anchor.href, window.location.origin); } catch { return; }
      const placement = anchor.closest(".resultsFooter") ? "results" : anchor.closest("nav") ? "navigation" : anchor.closest("footer,.footerPanel") ? "footer" : "content";
      if (["buymeacoffee.com", "www.buymeacoffee.com"].includes(url.hostname)) {
        trackEvent("support_click", { page_path: pathname, placement });
      } else if (url.origin === window.location.origin && url.pathname !== pathname && reportablePath(url.pathname) !== "/404") {
        trackEvent(calculatorPaths.has(url.pathname) ? "related_tool_click" : "internal_link_click", { page_path: pathname, destination_path: url.pathname, placement });
      }
    };
    document.addEventListener("input", onInput);
    document.addEventListener("change", onInput);
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("input", onInput);
      document.removeEventListener("change", onInput);
      document.removeEventListener("click", onClick);
    };
  }, [pathname]);
  return null;
}
